import React, { useState, useEffect, useRef } from "react";
import Tree from "react-d3-tree";
import styled from "styled-components";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import initialData from "./TreeData";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import LinearProgress from "@mui/material/LinearProgress";

const Container = styled.div`
    display: flex;
    flex-direction: row;
    padding: 15px 0px 15px 15px;
    position: relative;
`;

const TreeContainer = styled.div`
    width: 100%;
    height: 675px;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px;
    background-color: #e9e9e9;
    overflow: auto;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const DetailItem = styled.p`
    margin: 10px 0;
    span {
        display: inline-block;
        width: 100px;
        font-weight: regular;
    }
`;

const Loader = styled.div`
   width: 48px;
    height: 48px;
    border: 5px solid #000;
    border-bottom-color: transparent;
    border-radius: 50%;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    display: flex;
    justify-content: center;
    align-items: center;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;
const svgStyle = `
  .custom-svg {
    transform: translate(630px, 350px) scale(0.75) !important;
  }
`;

const levelColors = {
    1: "#E57373", // Red
    2: "#F06292", // Pink
    3: "#BA68C8", // Purple
    4: "#64B5F6", // Blue
    5: "#4FC3F7", // Light Blue
    6: "#4DB6AC", // Teal
    7: "#81C784", // Green
    8: "#DCE775", // Lime
    9: "#FFD54F", // Yellow
    10: "#FFB74D", // Orange
    11: "#A1887F", // Brown
    12: "#E0E0E0", // Grey
};

const GenealogyTree = () => {
    const navigate = useNavigate();
    //   const [treeData, setTreeData] = useState(initialData);
    const [treeData, setTreeData] = useState({});
    const [selectedNodeId, setSelectedNodeId] = useState(null);
    const [showAddButton, setShowAddButton] = useState(false);
    const [hoveredNodeId, setHoveredNodeId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [newMemberDetails, setNewMemberDetails] = useState({
        name: "",
        downlineNumber: "",
        username: "",
        downlineId: "",
        dateOfJoining: "",
        level: 1,
        referralEarnings: 0,
        weeklyEarnings: 0,
        totalEarnings: 0,
    });

    const [loading, setLoading] = useState(false);

    const formRef = useRef(null);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const initialValues = {
        first_name: "",
        last_name: "",
        user_name: "",
        password: "",
        user_email: "",
        user_status: 0,
        parent_key: "",
        referred_by: sessionStorage.getItem("pk_user_key"),
        created_by: sessionStorage.getItem("pk_user_key"),
    };

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    const basicSchema = Yup.object().shape({
        first_name: Yup.string()
            .min(3, "First Name must be at least 3 characters.")
            .max(50, "First Name must be at most 50 characters.")
            .matches(/^[a-zA-Z\s]*$/, "Only letters are allowed.")
            .matches(/^[^\s].*[^\s]$/, "No leading or trailing spaces are allowed.")
            .required("First Name is required."),

        last_name: Yup.string()
            .min(1, "Last Name must be at least 1 character.")
            .max(50, "Last Name must be at most 50 characters.")
            .matches(/^[a-zA-Z\s]*$/, "Only letters are allowed.")
            .matches(/^[a-zA-Z]+$/, "No leading or trailing spaces are allowed.")
            .required("Last Name is required."),

        user_name: Yup.string()
            .required("Username is required.")
            .matches(
                /^[a-zA-Z][a-zA-Z0-9_]{2,19}/,
                "Username must be 3-20 characters long, start with a letter, and can only contain letters, numbers, and underscores."
            )
            .matches(/^[^\s].*[^\s]$/, "No leading or trailing spaces are allowed.")
            .matches(/^(?!.*__)/, "Username cannot contain consecutive underscores.")
            .test("unique-link", "This username is already taken. Please choose another one.", async function (value) {
                if (!value) return true;
                const isUserNameUnique = await checkUserName(value);
                return isUserNameUnique;
            }),

        password: Yup.string()
            .min(8, "Password must be at least 8 characters.")
            .max(100, "Password must be at most 100 characters.")
            .matches(/[a-zA-Z]/, "Password must contain at least one letter.")
            .matches(/\d/, "Password must contain at least one number.")
            .matches(/[@$!%*?&#]/, "Password must contain at least one special character.")
            .required("Password is required."),

        user_email: Yup.string()
            .email("Invalid email address.")
            .required("email is required.")
            .test("valid-domain", "Invalid domain format.", function (value) {
                const domainPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return domainPattern.test(value || "");
            })
            .test("unique-link", "User Email is already existing in the database", async function (value) {
                if (!value) return true;
                const isUserEmailUnique = await checkUserEmail(value);
                return isUserEmailUnique;
            }),
    });

    async function checkUserName(user_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkUserName",
            user_name: user_name,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    async function checkUserEmail(user_email) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkUserEmail",
            user_email: user_email,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "addGenealogyMemberData",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                resetFormFields(resetForm, setValues, initialValues);
                handleCloseModal();
                toast.success("Added successfully!", {
                    autoClose: 3000,
                });
                getGenealogyTreeData();
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    const { values, handleChange, handleBlur, touched, errors, handleSubmit, setFieldValue, resetForm, setValues, setTouched } = formik;

    useEffect(() => {
        getGenealogyTreeData();
    }, []);

    const getGenealogyTreeData = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getGenealogyTreeData",
            user_key: sessionStorage.getItem("pk_user_key"),
        });

        const output = response.data;

        if (output.length > 0) {
            setTreeData(output);
            // console.log(output);
        }
    };

    const generateUniqueId = () => `${Date.now()}`;

    // Generate a unique downline number based on the parent's downline number
    const generateDownlineNumber = (parentNumber, children) => {
        if (!parentNumber) return "D1";
        const childNumbers = children.map((child) => child.downlineNumber);
        let newNumber = 1;
        while (childNumbers.includes(`${parentNumber}.${newNumber}`)) newNumber++;
        return `${parentNumber}.${newNumber}`;
    };

    // Add a new node to the tree data
    const addNodeToTree = (node, newNode) => {
        if (node.id === selectedNodeId) {
            if (node.children && node.children.length >= 12) return false;
            node.children = [...(node.children || []), newNode];
            return true;
        }
        if (node.children) {
            for (const child of node.children) {
                if (addNodeToTree(child, newNode)) {
                    return true;
                }
            }
        }
        return false;
    };

    const updateLevels = (node, level) => {
        node.attributes.level = level;
        if (node.children) {
            for (const child of node.children) {
                updateLevels(child, level + 1);
            }
        }
    };

    const handleNodeClick = (nodeDatum) => {
        setFieldValue("parent_key", nodeDatum.id);
        setLoading(true);
        setTimeout(() => {
            setSelectedNodeId(nodeDatum.id);
            setShowAddButton(true);
            setLoading(false);
        }, 500);

        setNewMemberDetails({
            name: nodeDatum.name || "New Member",
            downlineNumber: nodeDatum.downlineNumber,
            username: nodeDatum.attributes?.username || "",
            downlineId: nodeDatum.attributes?.downlineId || "",
            dateOfJoining: nodeDatum.attributes?.dateOfJoining || "",
            level: nodeDatum.attributes?.level || 1,
            downlineMembers: nodeDatum.downlineMembers,
            referralEarnings: nodeDatum.attributes?.referralEarnings || 0,
            weeklyEarnings: nodeDatum.attributes?.weeklyEarnings || 0,
            totalEarnings: nodeDatum.attributes?.totalEarnings || 0,
        });
    };

    const handleAddMember = () => {
        if (selectedNodeId) {
            const parentNode = findNodeById(treeData, selectedNodeId);
            if (parentNode.attributes.level >= 7) {
                alert("Maximum level reached. Cannot add more members.");
                return;
            }

            // Create a new member object
            const newMember = {
                name: newMemberDetails.name || "New Member",
                id: newMemberDetails.downlineId || generateUniqueId(),
                downlineNumber: generateDownlineNumber(parentNode.downlineNumber, parentNode.children),
                attributes: {
                    username: newMemberDetails.username || "Newuser",
                    downlineId: newMemberDetails.downlineId || generateUniqueId(),
                    dateOfJoining: newMemberDetails.dateOfJoining || new Date().toISOString().split("T")[0],
                    level: parentNode.attributes.level + 1, // Set the level of the new member
                    referralEarnings: newMemberDetails.referralEarnings || 0,
                    weeklyEarnings: newMemberDetails.weeklyEarnings || 0,
                    totalEarnings: newMemberDetails.totalEarnings || 0,
                },
                children: [],
            };

            // Add the new member to the tree
            const updatedTreeData = { ...treeData };
            if (addNodeToTree(updatedTreeData, newMember)) {
                // Update levels starting from the newly added member
                updateLevels(updatedTreeData, 1); // Assuming the root starts at level 1

                setTreeData(updatedTreeData);
                setShowAddButton(false);
                setShowModal(false);
            } else {
                alert("This node already has the maximum number of children.");
            }
        }
    };

    const findNodeById = (node, id) => {
        if (node.id === id) return node;
        if (node.children) {
            for (const child of node.children) {
                const foundNode = findNodeById(child, id);
                if (foundNode) return foundNode;
            }
        }
        return null;
    };

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setNewMemberDetails((prevDetails) => ({
    //         ...prevDetails,
    //         [name]: value,
    //     }));
    // };
    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const hasChildren = (node) => node.children && node.children.length > 0;

    const renderRectSvgNode = ({ nodeDatum, onNodeClick, selectedNodeId }) => {
        const isHovered = nodeDatum.id === selectedNodeId;
        const level = nodeDatum.attributes?.level || 1; // Default to level 1 if not specified

        // Define colors for different levels
        let levelColors;

        if (level === 1) {
            levelColors = "#fcf6ff";
        } else if (level === 2) {
            levelColors = "#DEF2FF";
        } else if (level === 3) {
            levelColors = "#FEEEE6";
        } else if (level === 4) {
            levelColors = "#E0FBE2";
        } else if (level === 5) {
            levelColors = "#EADBC8";
        } else if (level === 6) {
            levelColors = "#DDDDDD";
        } else if (level === 7) {
            levelColors = "#F9F7C9";
        } else if (level === 8) {
            levelColors = "#4DB6AC";
        } else if (level === 9) {
            levelColors = "#FFD54F";
        } else if (level === 10) {
            levelColors = "#4FC3F7";
        } else if (level === 11) {
            levelColors = "#E0E0E0";
        } else if (level === 12) {
            levelColors = "#FFB74D";
        }

        const fillColor = levelColors;

        return (
            <g
                className={`tree-home ${isHovered ? "selected" : " "}`}
                onClick={() => onNodeClick(nodeDatum)}
                onMouseEnter={() => handleNodeClick(nodeDatum)}
                onMouseLeave={() => {
                    setHoveredNodeId(null);
                    setShowAddButton(false);
                }}
            >
                <rect
                    width={isHovered ? 120 : 120}
                    height={isHovered ? 100 : 100}
                    x={isHovered ? -60 : -60}
                    y={isHovered ? -50 : -50}
                    fill={isHovered ? "#fff" : fillColor}
                    stroke={isHovered ? "#000" : "#000"}
                    strokeWidth={isHovered ? 2 : 2}
                    rx={isHovered ? 10 : 10}
                    ry={isHovered ? 10 : 10}
                />
                <rect width="40" height="40" x="-20" y="-35" fill="black" ry="40" rx="30" />
                <text fill="#fff" x="0" y="-9" textAnchor="middle" fontSize="22px" fontWeight="bold">
                    {nodeDatum.downlineNumber}
                </text>
                <text fill="#000" x="0" y="30" textAnchor="middle" fontSize="12px">
                    {nodeDatum.name}
                </text>
                {isHovered && showAddButton && (
                    <foreignObject x={20} y={45} width={50} height={40}>
                        {showAddButton && (
                            <Button
                                onClick={() => setShowModal(true)}
                                style={{
                                    fontSize: "16px",
                                }}
                                className="btn btn-dark p-1 mt-2 text-white d-flex justify-content-center align-items-center"
                            >
                                <FaPlus />
                            </Button>
                        )}
                    </foreignObject>
                )}
            </g>
        );
    };

    useEffect(() => {
        // Append the custom style to the head of the document
        const style = document.createElement("style");
        style.innerHTML = svgStyle;
        document.head.appendChild(style);

        // Cleanup style when component unmounts
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <>
            <ToastContainer position="top-center" />
            <section className="pb-3 container-fluid">
                <div className="main-content">
                    <h3 className="page-title">Genealogy Tree</h3>
                    <div className="downline-members-container">
                        <TreeContainer>
                            <Tree
                                data={treeData}
                                orientation="vertical"
                                translate={{ x: 625, y: 250 }}
                                // zoom={0.05}
                                zoom={0.43}
                                svgStyle={{
                                    transform: "translate(630px, 350px) scale(0.75) !important",
                                    transformOrigin: "0 0",
                                }}
                                pathFunc={"step"}
                                renderCustomNodeElement={(rd3tProps) =>
                                    renderRectSvgNode({
                                        ...rd3tProps,
                                        onNodeClick: handleNodeClick,
                                        selectedNodeId: selectedNodeId,
                                    })
                                }
                                styles={{
                                    nodes: {
                                        node: {
                                            name: { stroke: "#000000", fontSize: "12px" },
                                            attributes: { stroke: "#000000", fontSize: "10px" },
                                        },
                                    },
                                }}
                            />
                            <div
                                className="Level-info bg-white border rounded-3"
                                // style={{ width: "10%" }}
                            >
                                <ul className="w-100 p-2">
                                    <li className="d-flex justify-content-between align-items-center mb-2">
                                        <p className="level-count mb-0">Level 1</p>
                                        <p className="level-color level-1 mb-0"></p>
                                    </li>
                                    <li className="d-flex justify-content-between align-items-center mb-2">
                                        <p className="level-count mb-0">Level 2</p>
                                        <p className="level-color level-2 mb-0"></p>
                                    </li>
                                    <li className="d-flex justify-content-between align-items-center mb-2">
                                        <p className="level-count mb-0">Level 3</p>
                                        <p className="level-color level-3 mb-0"></p>
                                    </li>
                                    <li className="d-flex justify-content-between align-items-center mb-2">
                                        <p className="level-count mb-0">Level 4</p>
                                        <p className="level-color level-4 mb-0"></p>
                                    </li>
                                    <li className="d-flex justify-content-between align-items-center mb-2">
                                        <p className="level-count mb-0">Level 5</p>
                                        <p className="level-color level-5 mb-0"></p>
                                    </li>
                                    <li className="d-flex justify-content-between align-items-center mb-2">
                                        <p className="level-count mb-0">Level 6</p>
                                        <p className="level-color level-6 mb-0"></p>
                                    </li>
                                    <li className="d-flex justify-content-between align-items-center mb-2">
                                        <p className="level-count mb-0">Level 7</p>
                                        <p className="level-color level-7 mb-0"></p>
                                    </li>
                                    {/* <li className="d-flex justify-content-between align-items-center">
                    <p className="level-count mb-0">Level 8</p>
                    <p>
                      <span className="level-color level-8"></span>
                    </p>
                  </li>
                  <li className="d-flex justify-content-between align-items-center">
                    <p className="level-count mb-0">Level 9</p>
                    <p>
                      <span className="level-color level-9"></span>
                    </p>
                  </li>
                  <li className="d-flex justify-content-between align-items-center">
                    <p className="level-count mb-0">Level 10</p>
                    <p>
                      <span className="level-color level-10"></span>
                    </p>
                  </li>
                  <li className="d-flex justify-content-between align-items-center">
                    <p className="level-count mb-0">Level 11</p>
                    <p>
                      <span className="level-color level-11"></span>
                    </p>
                  </li>
                  <li className="d-flex justify-content-between align-items-center">
                    <p className="level-count mb-0">Level 12</p>
                    <p>
                      <span className="level-color level-12"></span>
                    </p>
                  </li> */}
                                </ul>
                            </div>

                            <div className="user-details ms-3">
                                {loading ? (
                                    <div className="d-flex justify-content-center align-items-center h-100">
                                        <Loader></Loader>
                                    </div>
                                ) : selectedNodeId ? (
                                    <>
                                        <h4 className="mt-2">Member Details</h4>
                                        <DetailItem>
                                            <div className=" d-flex">
                                                <div className="box">
                                                    <div className="text-box">
                                                        <p>Name</p>
                                                        <strong>:</strong>
                                                        <span className="card-details">{newMemberDetails.name}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </DetailItem>
                                        {/* <DetailItem>
                                            <div className=" d-flex">
                                                <div className="box">
                                                    <div className="text-box">
                                                        <p>Downline ID</p>
                                                        <strong>:</strong>
                                                        <span className="card-details">{newMemberDetails.downlineId}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </DetailItem> */}
                                        <DetailItem>
                                            <div className=" d-flex">
                                                <div className="box">
                                                    <div className="text-box">
                                                        <p>Date of Joining</p>
                                                        <strong>:</strong>
                                                        <span className="card-details">{newMemberDetails.dateOfJoining}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </DetailItem>
                                        <DetailItem>
                                            <div className=" d-flex">
                                                <div className="box">
                                                    <div className="text-box">
                                                        <p>Level</p>
                                                        <strong>:</strong>
                                                        <span className="card-details">{newMemberDetails.level}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </DetailItem>
                                        <DetailItem>
                                            <div className=" d-flex">
                                                <div className="box">
                                                    <div className="text-box">
                                                        <p>Downline Members</p>
                                                        <strong>:</strong>
                                                        <span className="card-details">{newMemberDetails.downlineMembers}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </DetailItem>
                                        <DetailItem>
                                            <div className=" d-flex">
                                                <div className="box">
                                                    <div className="text-box">
                                                        <p>Referral Earnings</p>
                                                        <strong>:</strong>
                                                        <span className="card-details">${newMemberDetails.referralEarnings}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </DetailItem>
                                        <DetailItem>
                                            <div className=" d-flex">
                                                <div className="box">
                                                    <div className="text-box">
                                                        <p>Weekly Earnings</p>
                                                        <strong>:</strong>
                                                        <span className="card-details">${newMemberDetails.weeklyEarnings}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </DetailItem>
                                        <DetailItem>
                                            <div className=" d-flex">
                                                <div className="box">
                                                    <div className="text-box">
                                                        <p>Total Earnings</p>
                                                        <strong>:</strong>
                                                        <span className="card-details">${newMemberDetails.totalEarnings}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </DetailItem>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </TreeContainer>
                    </div>
                </div>
            </section>

            <style jsx>
                {`
                    .rd3t-node {
                        stroke: unset !important;
                    }
                    .rd3t-leaf-node {
                        stroke: unset !important;
                    }
                    .rd3t-svg {
                        transform: translate(630, 350), scale(0.75) !important;
                    }
                    .user-details {
                        flex: 1;
                        padding-left: 10px;
                        background-color: #f9f9f9;
                        // border: 1px solid #ccc;
                        border-radius: 8px;
                        // padding: 10px;
                        min-width: 300px;
                        position: absolute;
                        top: 10px;
                        right: 10px;
                    }

                    .user-details h2 {
                        font-size: 24px;
                        margin-top: 0;
                    }

                    .user-details p {
                        font-size: 16px;
                        margin-bottom: 8px;
                    }
                    .box {
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .text-box {
                        display: flex;
                        width: 100%;
                        justify-content: space-between;
                        align-items: center;
                    }
                    .text-box > p {
                        width: 145px;
                        margin-bottom: 0px !important;
                    }
                    .Level-info {
                        position: absolute;
                        top: 10px;
                        left: 10px;
                        content: "";
                        // height: 300px;
                        // overflow: scroll;
                        min-width: 150px;
                    }
                    .level-color {
                        width: 20px;
                        height: 20px;
                        display: inline-block;
                        // border-radius: 50%;
                    }

                    .level-1 {
                        background-color: #fcf6ff;
                        border: 1px solid #000;
                    }
                    .level-2 {
                        background-color: #def2ff;
                        border: 1px solid #000;
                    }
                    .level-3 {
                        background-color: #feeee6;
                        border: 1px solid #000;
                    }
                    .level-4 {
                        background-color: #e0fbe2;
                        border: 1px solid #000;
                    }
                    .level-5 {
                        background-color: #eadbc8;
                        border: 1px solid #000;
                    }
                    .level-6 {
                        background-color: #dddddd;
                        border: 1px solid #000;
                    }
                    .level-7 {
                        background-color: #f9f7c9;
                        border: 1px solid #000;
                    }
                    .level-8 {
                        background-color: #4db6ac;
                    }
                    .level-9 {
                        background-color: #ffd54f;
                    }
                    .level-10 {
                        background-color: #4fc3f7;
                    }
                    .level-11 {
                        background-color: #e0e0e0;
                    }
                    .level-12 {
                        background-color: #ffb74d;
                    }
                `}
            </style>

            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Form onSubmit={handleSubmit} ref={formRef}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add New Member</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="formName" className="mb-2">
                            <Form.Label>
                                First Name<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter first name"
                                name="first_name"
                                value={values.first_name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.first_name && touched.first_name && <p className="text-danger">{errors.first_name}</p>}
                        </Form.Group>

                        <Form.Group controlId="formName" className="mb-2">
                            <Form.Label>
                                Last Name<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter last name"
                                name="last_name"
                                value={values.last_name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.last_name && touched.last_name && <p className="text-danger">{errors.last_name}</p>}
                        </Form.Group>

                        <Form.Group controlId="formUsername" className="mb-2">
                            <Form.Label>
                                User Name<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter username"
                                name="user_name"
                                value={values.user_name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.user_name && touched.user_name && <p className="text-danger">{errors.user_name}</p>}
                        </Form.Group>

                        <Form.Group controlId="formPassword" className="mb-2">
                            <Form.Label>
                                User password <span className="text-danger">*</span>
                            </Form.Label>
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter password"
                                    name="password"
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    autocomplete="new-password"
                                />
                                <span style={{ position: "absolute", top: "10px", right: "10px" }}>
                                    <a role="button" onClick={toggleShowPassword}>
                                        {showPassword ? <i class="bi bi-eye-slash-fill"></i> : <i class="bi bi-eye-fill"></i>}
                                    </a>
                                </span>
                            </div>
                            {errors.password && touched.password && <p className="text-danger">{errors.password}</p>}
                        </Form.Group>

                        <Form.Group controlId="formUseremail" className="mb-2">
                            <Form.Label>
                                User Email<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter user email"
                                name="user_email"
                                value={values.user_email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.user_email && touched.user_email && <p className="text-danger">{errors.user_email}</p>}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" className="ms-2" onClick={handleCloseModal}>
                            Cancel
                        </Button>
                        <Button variant="dark" type="submit" disabled={isSubmitting}>
                            Add Member
                            {isSubmitting && <LinearProgress />}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
};

export default GenealogyTree;
